import { useAuth } from "../context/AuthContext";

/**
 * The tenant's configured display timezone (Settings → Locale → "Company Timezone"),
 * so date/time displays don't silently vary with the viewing browser's local timezone.
 *
 * Sourced from `/api/auth/me` (available to every authenticated role) rather than
 * `/api/settings/locale`, which is admin/admin_assistant-only and would 403 for
 * employees, recruiters, etc.
 */
export function useTenantTimezone(): string {
  const { user } = useAuth();
  return user?.timezone || "UTC";
}
